import { liveFaqSearch, initFaqSearchBar } from '../utilities/_faq-search';
const { Collapse } = globalThis.unlk;

const bodyFaq = document.body.classList.contains('post-type-archive-faq');
const searchInput = document.querySelector('#s');
const searchForm = document.querySelector('#search-form');
const noFaqResult = document.querySelector('#noFaqResult');

if (bodyFaq) {
  document.addEventListener('DOMContentLoaded', faqInit);
}

function faqInit() {
  faqNav();
  faqSearchBar();
  faqHashOpen();
}

function faqHashOpen() {
  const hash = globalThis.location.hash.slice(1);
  if (!hash) return;

  const header = document.getElementById(hash);
  if (!header || !header.classList.contains('accordion-header')) return;

  const collapseEl = header.nextElementSibling;
  if (!collapseEl) return;

  // Close all default-open items
  for (const openItem of document.querySelectorAll('.accordion-collapse.show')) {
    if (openItem !== collapseEl) {
      Collapse.getOrCreateInstance(openItem, { toggle: false }).hide();
    }
  }

  // Open the target item
  Collapse.getOrCreateInstance(collapseEl, { toggle: false }).show();

  // Scroll after Bootstrap transition
  collapseEl.addEventListener('shown.bs.collapse', () => {
    header.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, { once: true });
}

function faqNav() {
  const triggers = document.querySelectorAll('li.filter');
  const faqSections = document.querySelectorAll('.accordion-section-item');

  // filter tabs
  for (const element of triggers) {
    element.addEventListener('click', () => {
      clearActive();
      element.classList.add('active');

      const { filter } = element.dataset;

      for (const faqSection of faqSections) {
        faqSection.classList.toggle('hide', !faqSection.classList.contains(filter));
      }

      if (filter === 'all') {
        for (const faqSection of faqSections) {
          faqSection.classList.remove('hide');
        }
      }
    });
  }

  // set active class on a faq menu
  const menu = document.querySelector('#faqs');
  if (!menu) return;

  const links = menu.getElementsByClassName('nav-link');
  const hash = globalThis.location.hash.slice(1);

  for (const link of links) {
    if (hash) {
      const curHash = link.hash.split('#')[1];
      const parent = link.parentNode;
      parent.classList.remove('active');
      if (curHash === hash) {
        parent.classList.add('active');
      }
    }

    link.addEventListener('click', function (e) {
      e.preventDefault();

      const current = menu.getElementsByClassName('active');
      if (current.length > 0) {
        current[0].classList.remove('active');
      }

      this.parentNode.classList.add('active');

      const mobileTriggerSpan = document.querySelector('.mobile-menu-trigger button span');
      const activeLink = document.querySelector('li.active a');
      if (mobileTriggerSpan && activeLink) {
        mobileTriggerSpan.textContent = activeLink.textContent;
      }
    });
  }
}

function clearActive() {
  const activeLink = document.querySelector('li.filter.active');
  if (activeLink) {
    activeLink.classList.remove('active');
  }
}

function faqSearchBar() {
  initFaqSearchBar({
    searchInput,
    searchForm,
    onSearch: () => liveFaqSearch({ searchInput, noFaqResult })
  });
}
